//@mui
import { Box, Checkbox, Collapse } from '@mui/material';
//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
//components
import { FormCard } from 'theme/elements/Forms';
import { FormHeader1, FormHeadWithCheckbox } from 'theme/elements/Headers';
//constants
import { formPropType } from './constants';

export default function FormWrap(props: formPropType) {
	const t = useAppSelector(selectTranslations);
	const prefixFields = 'page.beneficiary.create.step.2.';
	return (
		<Box component="form" noValidate>
			<FormCard>
				<FormHeadWithCheckbox>
					<>
						{props.isOptional && (
							<Checkbox
								sx={{ padding: 0, alignItems: 'start', marginTop: '4px' }}
								onChange={(event) => {
									props.setOptionalPayments(props.payment, event.target.checked);
								}}
								checked={props.optionalPayments[props.payment].optional}
								disabled={props.disabled}
							/>
						)}
					</>
					<FormHeader1
						title={t(`${prefixFields}${props.optionalPayments[props.payment].type}.title`)}
						text=""
					/>
				</FormHeadWithCheckbox>
				<Collapse in={props.optionalPayments[props.payment].optional || !props.isOptional}>
					{props.children}
				</Collapse>
			</FormCard>
		</Box>
	);
}
